/**
 * Subscription plan catalog management (platform admin) — /api/subscription-plans.
 */
import ApiService from './api.service';

const unwrap = (res) => (res && res.data ? res.data.data : null);

const SubscriptionPlanService = {
  list: async () => unwrap(await ApiService.get('/api/subscription-plans')) || [],
  get: async (id) => unwrap(await ApiService.get(`/api/subscription-plans/${id}`)),
  create: async (data) => unwrap(await ApiService.post('/api/subscription-plans', data)),
  update: async (id, data) => unwrap(await ApiService.put(`/api/subscription-plans/${id}`, data)),
  deactivate: async (id) => ApiService.delete(`/api/subscription-plans/${id}`),
  addPrice: async (id, data) => unwrap(await ApiService.post(`/api/subscription-plans/${id}/prices`, data)),
  removePrice: async (priceId) => ApiService.delete(`/api/subscription-plans/prices/${priceId}`),
  setEntitlement: async (id, data) => unwrap(await ApiService.put(`/api/subscription-plans/${id}/entitlements`, data)),
};

export default SubscriptionPlanService;
